import React from 'react'
import styles from './back-to-pupils.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import CarretLeftIcon from 'react-icons/lib/fa/caret-left'

const BackToPupils = ({ classes, className }) => (
  <Link to="/" className={classNames(classes.link, className)}>
    <CarretLeftIcon /> <span className={classes.back}>Back</span>{' '}
    <span className={classes.pupilsList}>to pupils list</span>
  </Link>
)

export default injectSheet(styles)(BackToPupils)
